import {environment} from "../../../environments/environment";

export class CommonConstants {
  /*## Interceptor Error Message ##*/
  public static INTERNAL_SERVER_ERROR = 'An internal server error occurred.';
  /*## Interceptor Error Message ##*/

  /*## Common Constants ##*/
  public static IS_DEFAULT_ADDRESS_YES = 'Y';
  public static IS_DEFAULT_ADDRESS_NO = 'N';
  public static USER_TYPE_TRADE = 'Trade';
  public static STATUS_ACTIVE = 'A';
  public static PAGE_SIZE_ALL = 'all';
  public static DEFAULT_PAGE_SIZE_FOR_SEARCH_PAGE = 12;
  public static WAREHOUSE_COLLECTION_TRUCK_TYPE = 'Client Organized Order Collection';
  public static SURFACE_SORT_NAME = 'S';
  public static PRODUCT_TYPE_SM = 'SM';
  public static IS_DISPLAY_TRANSACTION_HISTORY = 'Y';
  public static PO_BOX_ADDRESS_REGEX = /\b(?:p\.?\s*o\.?|post\s+office)(\s+)?(?:box|[0-9]*)?\b/i
  public static DOWNLOAD_QUOTE = 'DQ';
  public static DOWNLOAD_INVOICE = 'DI';
  public static DOWNLOAD_PAYMENT_RECEIPT = 'DPR';
  public static SHARE_QUOTE = 'SQ';
  public static SHARE_INVOICE = 'SI';
  public static SHARE_TRACKING_LINK = 'STL';
  public static SHARE_PAYMENT_RECEIPT = 'SPR';
  public static ORDER_TAB_ALL = 'all-order';
  public static ORDER_TAB_AWAITING_PAYMENT = 'awaiting-payment';
  public static ORDER_TAB_PAYMENT_DUE = 'payment-due';
  public static ORDER_TAB_PAYMENT_COMPLETE = 'payment-complete';
  public static ORDER_TAB_COMPLETE = 'order-complete';
  public static ORDER_TAB_CANCELLED = 'order-cancelled';
  public static ORDER_TAB_ALL_NO_RECORD_MESSAGE = 'You currently have no orders owing';
  public static ORDER_TAB_AWAITING_PAYMENT_NO_RECORD_MESSAGE = 'You currently have no awaiting payments owing';
  public static ORDER_TAB_PAYMENT_DUE_NO_RECORD_MESSAGE = 'You currently have no payment due owing';
  public static ORDER_TAB_PAYMENT_COMPLETE_NO_RECORD_MESSAGE = 'You currently have no completed payment owing';
  public static ORDER_TAB_COMPLETE_NO_RECORD_MESSAGE = 'You currently have no completed order owing';
  public static ORDER_TAB_CANCELLED_NO_RECORD_MESSAGE = 'You currently have no cancelled order owing';
  public static HERO_CATEGORY_SKU_YES = 'YES';
  public static STATUS_ACTIVE_SHORT = 'A';
  public static TAX_GST_PERCENTAGE = 10;
  public static DOWNLOAD_ADHESIVE_AND_PREMIUM_SEALING_PROCEDURES = 'https://www.dropbox.com/sh/765hfjdnvvtl74n/AABZ91Wp9WwGOz_J_0Vvw1P9a?dl=0';
  public static CONSUMABLE_CALCULATOR_TYPE_ADHESIVE = 'laticrete_adhesive';
  public static CONSUMABLE_CALCULATOR_TYPE_DEFENDER = 'defender';
  public static CONSUMABLE_CALCULATOR_TYPE_GOLD = 'gold';
  public static FORK_TRUCK_ID = 1;
  public static HIAB_TRUCK_ID = 2;
  public static FLATAB_TRUCK_ID = 3;
  public static OTHER_TRUCK_ID = 4;
  public static IS_TWO_FACTOR_VERIFIED = 'Y'
  public static IS_ARCHIVE_YES = 'Y';
  public static PAYMENT_TYPE_FULL = 'FL';
  public static PAYMENT_TYPE_FINAL = 'FP';
  public static PAYMENT_TYPE_DEPOSIT = 'DP';
  public static PAYMENT_TYPE_PARTIAL = 'PP';
  public static QUANTITY_LENGTH = 9999
  public static FILTER_AVAILABLE_STRING = [
    'Available',
    'available',
  ];
  public static FILTER_LOW_AVAILABLE_STRING = [
    'Low Stock',
  ];

  public static LEAD_TIME_IN_STOCK = 'In Stock'
  public static LEAD_TIME_LOW_STOCK = 'Low Stock'
  public static LIMITED_STOCK_ONLY = 'Limited Sale Stock Only weeks'

  public static TC_OUTLINE_ID = "outline"
  public static TC_QUOTES_AND_ORDERS_ID = "quotes-and-orders"
  public static TC_PRICE_ID = "price"
  public static TC_PAYMENT_ID = "payment"
  public static TC_PAYMENT_DEFAULT_ID = "payment-default"
  public static TC_DELIVERY_INSURANCE_ID = "delivery-insurance"
  public static TC_SUSPENSION_CANCELLATION_ID = "suspension-cancellation"
  public static TC_DEFECTS_RETURNS_ID = "defects-returns"
  public static TC_EXCLUSIONS_LIMITATIONSE_ID = "exclusions-limitations"
  public static TC_STATUTORY_RIGHTS_ID = "statutory-rights"
  public static TC_TITLE_ID = "title"
  public static TC_SECURITY_INTERESTE_ID = "security-interest"
  public static TC_INTELLECTUAL_PROPERTY_ID = "intellectual-property"
  public static TC_INTELLECTUAL_GST_ID = "intellectual-gst"
  public static TC_GENERAL_ID = "general"
  public static TC_WARRANTY_DEFECTS_ID = "warranty-defects"
  public static TC_INTERPRETATIONS_DEFINITIONS_ID = "interpretations-definitions"
  public static PRODUCT_DELETED_YES = 1;
  public static APPLY_GLUE_CALCULATOR_YES = 'YES';
  public static SEAMLESS_ARRAY = [
    'ASSETS/PRODUCT/SEAMLESS_TEXTURE/GatherCo_Apis_Limestone_PaulBrace_1.webp',
    'ASSETS/PRODUCT/SEAMLESS_TEXTURE/GatherCo_Bastion_Limestone_PaulAlexander_2.webp',
    'ASSETS/PRODUCT/SEAMLESS_TEXTURE/GatherCo_Bastion_Limestone_PaulBrace_3.webp',
    'ASSETS/PRODUCT/SEAMLESS_TEXTURE/GatherCo_Bombala_Limestone_PaulAlexander_4.webp',
    'ASSETS/PRODUCT/SEAMLESS_TEXTURE/GatherCo_Chesterfield_Marble_PaulAlexander_5.webp',
    'ASSETS/PRODUCT/SEAMLESS_TEXTURE/GatherCo_Dias_Granite_PaulAlexander_6.webp',
    'ASSETS/PRODUCT/SEAMLESS_TEXTURE/GatherCo_Flinders_Quartz_FabricArchitecture_7.webp',
    'ASSETS/PRODUCT/SEAMLESS_TEXTURE/GatherCo_Hampton_Quartz_CollinsTurnerArchitects_8.webp',
    'ASSETS/PRODUCT/SEAMLESS_TEXTURE/GatherCo_Ironwood_Travertine_PaulAlexander_9.webp',
    'ASSETS/PRODUCT/SEAMLESS_TEXTURE/GatherCo_Kesi_Limestone_PaulAlexander_10.webp',
    'ASSETS/PRODUCT/SEAMLESS_TEXTURE/GatherCo_Zahri_Limestone_Malina_Terracotta_TheStrandAgency_11.webp',
    'ASSETS/PRODUCT/SEAMLESS_TEXTURE/GatherCo_Zahri_Limestone_PaulAlexander_12.webp',
    'ASSETS/PRODUCT/SEAMLESS_TEXTURE/GatherCo_Zahri_Limestone_PaulAlexander1_13.webp',
    'ASSETS/PRODUCT/SEAMLESS_TEXTURE/GatherCo_Zahri_Limestone_PaulAlexander2_14.webp'
  ]
  public static IS_MANUAL_SHIPPING_RATE_CHANGE_YES = 'Y';
  public static IS_MANUAL_SHIPPING_RATE_CHANGE_NO = 'N';
  public static IS_DISABLE_EXPIRY_DEADLINE_YES = 'Y';
  public static FILTER_PREMIUM_SEALER = ['DEFENDER', 'GOLD'];

  public static EXPORT_QUOTE_INVOICE_URL = environment.HOST_URL + '/quote-invoice';
  /*## Common Constants ##*/

  /*## ImageKit Constants ##*/
  public static S3_BUCKET_ENDPOINT = 'https://gatherco.s3.ap-southeast-2.amazonaws.com'
  public static IMAGE_KIT_ENDPOINT = environment.IMAGE_KIT_ENDPOINT;
  public static NO_IMAGE_PRODUCT = environment.IMAGE_KIT_ENDPOINT + '/ASSETS/GENERAL/IMAGES/no-image-product.svg';
  public static S3_MAKER_MARK_IMAGE_KIT_FOLDER = '/ASSETS/PRODUCT/MAKERS_MARKS'
  public static S3_MAKER_MARK_IMAGE_KIT_URL = environment.IMAGE_KIT_ENDPOINT + '/ASSETS/PRODUCT/MAKERS_MARKS'
  public static S3_FINISH_SPECIFICATION_IMAGE_KIT_FOLDER = '/ASSETS/PRODUCT/SPECIFICATION'
  public static S3_FINISH_SPECIFICATION_IMAGE_KIT_URL = environment.IMAGE_KIT_ENDPOINT + this.S3_FINISH_SPECIFICATION_IMAGE_KIT_FOLDER
  public static S3_ACCOUNT_LOGO_IMAGE_KIT_URL = environment.IMAGE_KIT_ENDPOINT + '/account-logo';
  public static S3_PRODUCT_RESOURCE_IMAGE_KIT_URL = environment.IMAGE_KIT_ENDPOINT + '';
  public static S3_CLIENT_LOGO = environment.IMAGE_KIT_ENDPOINT + '/ASSETS/HOME/CLIENT_LOGO';
  /*## ImageKit Constants ##*/

  /*## General General/Success/Error Message ##*/
  public static SUCCESS_FORGOT_PASSWORD = 'A password reset link has been sent to your email. Use it to create a new password.';
  public static SUCCESS_RESET_PASSWORD = 'Your password has been updated.';
  public static SUCCESS_CHANGE_PASSWORD = 'Your password has been changed.';
  public static SUCCESS_USER_REGISTERED = 'Your account has been created.';
  public static SUCCESS_COMPANY_DETAIL_UPDATE = 'Company information has been updated.';
  public static SUCCESS_ACCOUNT_ADDRESS_CREATE = 'Business address has been added.';
  public static SUCCESS_ACCOUNT_ADDRESS_UPDATE = 'Business address has been updated.';
  public static SUCCESS_ACCOUNT_ADDRESS_DELETE = 'Business address has been deleted.';
  public static SUCCESS_ACCOUNT_ADDRESS_DEFAULT = 'Business address has been set as default.';
  public static SUCCESS_HOME_ADDRESS_DELETE = 'Home address has been deleted.';
  public static SUCCESS_HOME_ACCOUNT_ADDRESS_CREATE = 'Home address has been added.';
  public static SUCCESS_HOME_ACCOUNT_ADDRESS_UPDATE = 'Home address has been updated.';
  public static SUCCESS_HOME_ADDRESS_DEFAULT = 'Home address has been set as default.';
  public static SUCCESS_PRODUCT_ADDED_FOR_FAVORITE = 'Product has been added to your favorites.';
  public static SUCCESS_PRODUCT_REMOVED_FOR_FAVORITE = 'Product has been removed from your favorites.';
  public static ERROR_PRODUCT_FAVOURITE_WITHOUT_LOGIN = 'Please log in to add this product to your favorites.';
  public static PRODUCT_FINISH_PREVIEW_NOT_AVAILABLE = 'Sorry, finish is not available for this product.';
  public static SAMPLE_CREATED_SUCCESS_MESSAGE = 'Sample order has been created.';
  public static SUCCESS_QUOTE_CREATED = 'Quote has been created.';
  public static SUCCESS_QUOTE_ACCEPTED = 'Quote has been accepted.';
  public static SUCCESS_MESSAGE_REACTIVE_QUOTE = 'Quote has been reactivated.';
  public static SUCCESS_INVOICE_EXPORTED = 'Invoice has been sent.';
  public static SUCCESS_VERIFICATION_CODE = 'A verification code has been sent to your email.';
  public static SUCCESS_REVIEW_ADD = "Thank you! Your review has been successfully added.";
  public static SUCCESS_REVIEW_EDIT = "Thank you! Your review has been successfully updated.";
  public static CONFIRM_MESSAGE_QUOTE_EXPIRE = 'Are you sure you want to reactivate this quote?';
  public static ORDER_ADDRESS_INVALID_ALERT_MESSAGE = "Please select a different address."
  public static ON_DONATE_CLICK_ERROR_MESSAGE = 'Please select a donation amount.';
  public static PAYMENT_FAILED = 'Payment failed. Please try again.';
  public static PAYMENT_SUCCESS = 'Order payment has been completed.';
  public static SUCCESS_MESSAGE_ON_EXPORT_QUOTE = 'Exported quote link has been sent to your email.';
  public static SUCCESS_MESSAGE_ON_EXPORT_ORDER = 'Exported order link has been sent to your email.';
  public static SUCCESS_MESSAGE_ON_EXPORT_ORDER_PAYMENT_RECEIPT = 'Payment receipt has been sent to your email.';
  public static PRODUCT_ADDED_SUCCESSFULLY = 'Product has been added.';
  public static QUOTE_DELIVERY_REQUEST_SENT_MESSAGE = "Delivery quote request has been sent.";
  public static INVALID_URL_ERROR = 'Invalid URL. Please enter a valid URL.';
  public static CART_PRODUCT_EXIST_MESSAGE = 'This product is already in your cart.';
  public static SAMPLE_PRODUCT_ADD_TO_CART_MESSAGE = 'Sample added to cart.';
  public static CODE_COPIED = 'Code has been copied to the clipboard.';
  public static FAILED_CODE_COPIED = 'Failed to copy the code.'
  public static FRONTEND_PREFIX = 'https://gatherco.com.au'
  public static FRONTEND_PREFIX_WITH_WWW = 'https://www.gatherco.com.au';
  public static IN_SHIPPING_ZONE_YES = 'Y';
  public static IN_SHIPPING_ZONE_NO = 'N';
  public static UNIT_OF_MEASUREMENT_SQM = 'SQM';
  public static UNIT_OF_MEASUREMENT_LM = 'LM';
  public static PIECE_CONSTANT_LONG_NAME = 'PIECE'
  public static TILES_CONSTANT_LONG_NAME = 'TILES'
  public static UNIT_OF_MEASUREMENT_PCS = 'PCS'
  public static STREET_NUMBER_REQUIRED = 'Please enter a valid address. The street number is missing.';
  public static PRODUCT_DETAIL_SIZING_TABLE_TOOLTIP = "Lead times are indicative only. Although we take great care to ensure they're kept accurate, stock levels are constantly fluctuating. Our best advice is always to place orders as early as possible, thus reducing the likelihood of supply related delays disrupting your construction schedule.";
  public static IN_STOCK_PRODUCT_TOOLTIP = "Stocked items have a standard delivery lead time of 5 days, from date of deposit payment.";
  public static EMAIL_IS_REQUIRED_FOR_PDF_EXPORT = `Please enter email address.`;
  public static TRACKING_NUMBER_COPIED = 'Tracking number copied.'
  public static WASTAGE_TOOLTIP = 'To guarantee sufficient material for your project, we recommend adding an additional 15% to account for potential cuts and unexpected breaks or splits during installation to the listed available quantity.'
  public static BILLER_CODE_COPY = 'Biller code copied.'
  public static REF_CODE_COPY = 'Ref code copied.'
  public static DUE_AMOUNT_COPY = 'Due amount copied.'
  public static WA_POSTAL_CODE_PREFIX = 6;

  public static ADDRESS_COPIED = 'Address copied.';
  public static QUOTE_INVOICE_LINK_COPIED = 'Quote invoice link copied.';
  public static PRODUCT_DOES_NOT_EXIST_MESSAGE = 'Product does not exist or is unavailable on our website.';
  public static UNABLE_QUOTE_DETAIL_CHANGE = 'This quote is archived. Please unarchive it first.';
  public static QUOTE_QUANTITY_UPDATED = 'Quantity has been updated.';
  public static ERROR_MESSAGE_OF_DELIVERY_ADDRESS_ON_QUOTE = 'Please add a delivery address.';
  public static ERROR_MESSAGE_OF_DELIVERY_ADDRESS_TRUCK_TYPE = 'Please select a truck type.';
  public static SUCCESS_MESSAGE_UPDATE_PROJECT_REFERENCE = "Project reference has been updated.";
  public static UNABLE_ORDER_DETAIL_CHANGE = 'This order is archived. Please unarchive it first.';
  public static QUANTITY_LENGTH_ERROR_MESSAGE = 'Quantity should not exceed 9999.';
  public static GATHERCO_CREDIT_APPLIED_SUCCESS = 'Gatherco credit has been applied.';
  public static GATHERCO_CREDIT_APPLIED_ERROR = 'Gatherco credit has not been applied.';
  public static SAMPLE_ORDER_ITEM_LIMIT_ERROR = 'You can only place 1 sample order per day a maximum of 6 items. Your limit has been exceeded.';
  public static STREET_NO_REQUIRED = 'Please enter a valid address. Street number is missing.'
  /*## General General/Success/Error Message ##*/

  /*## Confirmation Message ##*/
  public static CONFIRMATION_CART_PRODUCT_EXIST_TITLE = 'Alert';
  public static CONFIRMATION_CART_PRODUCT_EXIST_MESSAGE = 'This product already exists in your quote. Would you like to increase the quantity?';
  public static CONFIRMATION_CART_PRODUCT_DELETE_TITLE = 'Delete product';
  public static CONFIRMATION_CART_PRODUCT_DELETE_MESSAGE = 'This product will be removed from your cart. Are you sure you want to proceed?';
  public static CONFIRMATION_QUOTE_PRODUCT_DELETE_MESSAGE = 'This product will be removed from your quote. Are you sure you want to proceed?';
  public static CONFIRMATION_DELETE_QUOTE_TITLE = 'Delete Quote';
  public static CONFIRMATION_DELETE_QUOTE_MESSAGE = 'Deleted quotes cannot be restored. Are you sure you want to proceed?';
  /*## Confirmation Message ##*/

  /*## Product Table Constant ##*/
  public static PRODUCT_IS_FAVOURITE_YES = 'YES';
  public static PRODUCT_IS_FAVOURITE_NO = 'NO';
  public static PRODUCT_IS_SALE_YES = 'YES';
  public static PRODUCT_IS_FEATURE_PROFILE_YES = 'YES';
  public static PRODUCT_TYPE_SURFACE = 'S';
  public static PRODUCT_TYPE_SURFACE_ACCESSORY = 'SA';
  public static PRODUCT_TYPE_DECOR = 'D';
  public static PRODUCT_RESOURCE_DOWNLOAD = 'PR';
  public static PRODUCT_RESOURCE_DOWNLOAD_SORT = 'PSR';
  public static PRODUCT_IMAGE_DOWNLOAD_SORT = 'PSI';
  public static PRODUCT_VIDEO_DOWNLOAD_SORT = 'PSV';
  public static PRODUCT_SEAMLESS_TEXTURE_IMAGE_DOWNLOAD = 'STI';
  public static OTHER_SEAMLESS_TEXTURE_IMAGE_DOWNLOAD = 'OSTI';
  public static PRODUCT_SINGLE_SEAMLESS_TEXTURE_IMAGE_DOWNLOAD = 'SSTI';
  public static PRODUCT_PROJECT_IMAGERY = 'PRI';
  /*## Product Table Constant ##*/

  /*## Quote Table Constant ##*/
  public static QUOTE_TYPE_QUOTE = "Q";
  public static QUOTE_TYPE_ORDER = "O";
  public static QUOTE_TYPE_SAMPLE_ORDER = "SO";
  public static QUOTE_IS_EXPIRED_NO = "NO";
  public static QUOTE_IS_EXPIRED_YES = "YES";
  public static QUOTE_IS_DELETE_NO = "0";
  public static QUOTE_IS_ACCEPTED_YES = "Y";
  public static QUOTE_IS_ACCEPTED_NO = "N";
  public static QUOTE_IN_SHIPPING_ZONE_YES = "Y";
  public static QUOTE_IN_SHIPPING_ZONE_NO = "N";
  public static IS_DISPLAY_ACCEPTED_QUOTE_YES = "Y";
  public static QUOTE_IS_NOT_DRAFT = "N";
  public static ORDER_TAB_ALL_SHORT = "all";
  /*## Quote Table Constant ##*/

  /*## Price Range Constant ##*/
  public static IMAGE_SIZE_2268_X_940 = '?tr=w-2268,h-940,q-100,f-webp,e-sharpen-50';
  public static IMAGE_SIZE_877_X_877 = '?tr=w-877,h-877,q-100,f-webp,e-sharpen-50';
  public static IMAGE_SIZE_1200_X_630 = '?tr=w-1200,h-630,q-100,f-webp,e-sharpen-50';
  public static IMAGE_SIZE_96_X_96 = '?tr=w-96,h-96,q-100,f-webp,e-sharpen-50';
  public static IMAGE_SIZE_80_X_80 = '?tr=w-80,h-80,q-100,f-webp,e-sharpen-50';
  public static IMAGE_SIZE_70_X_70 = '?tr=w-70,h-70,q-100,f-webp,e-sharpen-50';
  public static IMAGE_SIZE_69_X_69 = '?tr=w-69,h-69,q-100,f-webp,e-sharpen-50';
  public static IMAGE_SIZE_62_X_62 = '?tr=w-62,h-62,q-100,f-webp,e-sharpen-50';
  public static IMAGE_SIZE_58_X_58 = '?tr=w-58,h-58,q-100,f-webp,e-sharpen-50';
  public static IMAGE_SIZE_54_X_54 = '?tr=w-54,h-54,q-100,f-webp,e-sharpen-50';
  public static IMAGE_SIZE_50_X_50 = '?tr=w-50,h-50,q-100,f-webp,e-sharpen-50';
  public static IMAGE_SIZE_38_X_38 = '?tr=w-38,h-38,q-100,f-webp,e-sharpen-50';
  public static IMAGE_SIZE_HEIGHT_500 = '?tr=h-500,q-100,f-webp,e-sharpen-50';
  public static IMAGE_SIZE_HEIGHT_935 = '?tr=h-935,q-100,f-webp,e-sharpen-50';
  public static IMAGE_WEBP_QUALITY_100 = '?tr=q-100,f-webp,e-sharpen-50';
  public static IMAGE_SIZE_HEIGHT_150 = '?tr=h-150,q-100,f-webp,e-sharpen-50';
  public static IMAGE_SIZE_WIDTH_1400 = '?tr=w-1400,q-100,f-webp,e-sharpen-50';
  public static IMAGE_SIZE_WIDTH_807 = '?tr=w-807,q-100,f-webp,e-sharpen-50';
  public static IMAGE_SIZE_WIDTH_394 = '?tr=w-394,q-100,f-webp,e-sharpen-50';
  public static IMAGE_SIZE_1010_X_652 = '?tr=w-1010,h-652,q-100,f-webp,e-sharpen-50';
  public static IMAGE_SIZE_704_X_551 = '?tr=w-704,h-551,q-100,f-webp,e-sharpen-50';
  /*## Image Size Declaration Constant ##*/

  /*## Quote Status Constant  ##*/
  public static QUOTE_ORDER_RECEIVED = 'OR';
  public static QUOTE_COMPLETED = 'C';
  public static ORDER_CANCELLED = 'OCAN';
  public static QUOTE_DELIVERED = 'D';
  public static QUOTE_FOLLOWUP = 'FU';
  public static QUOTE_CREATED_SHORT = 'QC';
  public static QUOTE_ACCEPTED_SHORT = 'QA';
  public static QUOTE_DELIVERY_ADDRESS_REQUIRED_SHORT = 'DAR';
  public static QUOTE_MANUAL_DELIVERY_QUOTE_REQUIRED_SHORT = 'MDQR';
  public static QUOTE_MANUAL_DELIVERY_QUOTE_ADDED_SHORT = 'MDQAD';
  public static QUOTE_MANUAL_DELIVERY_QUOTE_APPLIED_SHORT = 'MDQAP';
  public static QUOTE_DEPOSIT_PAYMENT_DUE_SHORT = 'DPDU';
  public static QUOTE_DEPOSIT_PAID_SHORT = 'DPD';
  public static QUOTE_EXPIRED_SHORT = 'EXP';
  public static QUOTE_AUTO_DELIVERY_QUOTE_APPLIED_SHORT = 'ADQAP';
  public static QUOTE_CLIENT_ORGANIZED_ORDER_COLLECTION_SHORT = 'COOC';
  public static QUOTE_DEPOSIT_PAYMENT_PROCESSING_SHORT = 'DPPROC';
  public static QUOTE_FINAL_PAYMENT_PROCESSING_SHORT = 'FPPROC';
  public static QUOTE_FULL_PAYMENT_PROCESSING_SHORT = 'FUPPROC';
  public static QUOTE_EXPIRY_IMMANENT_SHORT = 'QEI';
  public static QUOTE_DEPOSIT_EXPIRY_IMMANENT_SHORT = 'DEI';
  public static DELIVERY_ADDRESS_REQUIRED = 'Delivery Address Required';
  public static MANUAL_DELIVERY_QUOTE_REQUIRED = 'Manual Delivery Quote Required';
  public static MANUAL_DELIVERY_QUOTE_APPLIED = 'Manual Delivery Quote Applied';
  public static AUTO_DELIVERY_QUOTE_APPLIED = 'Auto Delivery Quote Applied';
  public static CLIENT_ORGANIZED_ORDER_COLLECTION = 'Client Organized Order Collection';
  public static QUOTE_STATUS_CANCELLED = 'QCAN';
  public static QUOTE_REACTIVATED_SHORT = 'QRA';
  /*## Quote Status Constant  ##*/

  /*## Order status Constant ##*/
  public static ORDER_RECEIVED_SHORT = 'OR';
  public static ORDER_PACKING_SHORT = 'AAW';
  public static ORDER_FINAL_PAYMENT_PENDING_SHORT = 'FPP';
  public static ORDER_GOODS_DISPATCHED_OUT_TO_TENDER_SHORT = 'GDOTT';
  public static ORDER_GOODS_DISPATCHED_SHORT = 'GD';
  public static ORDER_GOODS_DISPATCHED_ACCEPTED_SHORT = 'GDA';
  public static ORDER_GOODS_DISPATCHED_DECLINED_SHORT = 'GDD';
  public static ORDER_GOODS_DISPATCHED_CLIENT_ORGANIZED_SHORT = 'GDCO';
  public static ORDER_GOODS_DISPATCHED_DELIVERD_SHORT = 'GDDE';
  public static ORDER_COMPLETED_SHORT = 'C';
  public static ORDER_FOLLOW_UP_SHORT = 'FU';
  public static QUOTE_ORDER_RECEIVED_SHORT = 'OR';
  public static QUOTE_IN_PRODUCTION_SHORT = 'IP';
  public static QUOTE_GOODS_DISPATCHED_SHORT = 'GD';
  public static QUOTE_GOODS_DISPATCHED_DELIVERD_SHORT = 'GDDE';
  public static QUOTE_CLEARED_CUSTOMS_SHORT = 'CC';
  public static QUOTE_PACKING_SHORT = 'AAW';
  public static QUOTE_FINAL_PAYMENT_PENDING_SHORT = 'FPP';
  public static QUOTE_FINAL_PAYMENT_PAID_SHORT = 'FPPD';
  public static QUOTE_FULL_PAYMENT_PAID_SHORT = 'FUPP';
  public static QUOTE_DELAYED_IN_TRANSIT_SHORT = 'DIT';
  public static QUOTE_COMPLETED_SHORT = 'C';
  public static ORDER_STATUS_PAYMENT_OVERDUE = 'PO';
  public static ORDER_STATUS_PAYMENT_DELIVERY_APPROVAL = 'PDA';
  public static ORDER_STATUS_AWAITING_FINAL_PAYMENT = 'AFP';
  public static ORDER_STATUS_PAYMENT_COMPLETE = 'PCT';
  public static ORDER_STATUS_COMPLETED = 'C';
  public static ORDER_STATUS_CANCELLED = 'CAN';
  public static ORDER_STATUS_IN_TRANSITION = 'IT';
  /*## Order Status Constant ##*/

  /*## Activity TypeId Constant ##*/
  public static ACTIVITY_TYPE_DEPOSIT_PAYMENT_PAID_ID = 42;
  public static ACTIVITY_TYPE_PARTIAL_PAYMENT_PAID_ID = 45;
  /*## Activity TypeId Constant ##*/

  /*## Carrier Status Id Constant ##*/
  public static CARRIER_STATUS_UNSPECIFIED_ID = 1;
  public static CARRIER_STATUS_OUT_TO_TENDER_ID = 2;
  public static CARRIER_STATUS_DESPATCHED_ID = 3;
  public static CARRIER_STATUS_ACCEPTED_ID = 4;
  public static CARRIER_STATUS_DECLINED_ID = 5;
  public static CARRIER_STATUS_CLIENT_ORGANIZED_ID = 6;
  public static CARRIER_STATUS_DELIVERED_ID = 7;
  /*## Carrier Status Id Constant ##*/

  /*## Samples Status Constant ##*/
  public static GENERAL_USER_SAMPLE_ORDER_STATUS_ARRAY_VIEW_SAMPLES = [
    {
      name: 'Logged',
      class: 'received',
      status: ['OR'],
      label_class: 'recived-flag',
      model_header: 'Order Received'
    },
    {
      name: 'Packaged',
      class: 'packing',
      status: ['PC'],
      label_class: 'packaging-flag',
      model_header: 'Order Packaged'
    },
    {
      name: 'On its way',
      class: 'transit',
      status: ['OIW'],
      label_class: 'transit-flag',
      model_header: 'Order On Its Way'
    },
    {
      name: 'Delivered',
      class: 'delivered',
      status: ['D'],
      label_class: 'completed-flag',
      model_header: 'Order Delivered'
    },
    {
      name: 'Follow Up',
      class: 'follow-up',
      status: ['FU'],
      label_class: 'follow-up-flag',
      model_header: 'Order Delivered'
    },
    {
      name: 'Completed',
      class: 'completed',
      status: ['C'],
      label_class: 'completed-flag',
      model_header: 'Completed'
    }
  ];
  public static TRADE_SAMPLE_ORDER_STATUS_ARRAY = [
    {
      name: 'All',
      class: '',
      status: [],
      label_class: '',
      disable_class: '',
      color: '',
      background: ''
    },
    {
      name: 'Samples Requested',
      class: 'requested',
      status: ['OR'],
      label_class: 'recived-flag-sample',
      disable_class: 'sample-request-disable',
      color: '#D51ED2',
      background: '#D51ED2'
    },
    {
      name: 'Samples Packaged',
      class: 'packaged',
      status: ['PC'],
      label_class: 'packaging-flag',
      disable_class: 'package-disable',
      color: '#362E9B',
      background: '#362E9B'
    },
    {
      name: 'Samples Despatched',
      class: 'dispatched',
      status: ['OIW'],
      label_class: 'transit-flag',
      email_template_key: ['sample-dispatched'],
      disable_class: 'despatched-disable',
      color: '#B98000',
      background: '#B98000'
    },
    {
      name: 'Samples Delivered',
      class: 'delivered',
      status: ['D'],
      label_class: 'completed-flag',
      email_template_key: ['sample-order-complete'],
      disable_class: 'delivered-disable',
      color: '#222324',
      background: '#222324'
    },
    {
      name: 'Awaiting Feedback', status: ['FU'], label_class: 'followup-flag',
      class: 'follow-up',
      disable_class: 'follow-up-disable',
      color: '#6D709A',
      background: '#6D709A'
    },
    {
      name: 'Complete', status: ['C'], label_class: 'complete-flag',
      class: 'completed',
      disable_class: 'complete-disable',
      color: '#222324',
      background: '#222324'
    }
  ];
  /*## Samples Status Constant ##*/

  /*## Quote Status Constant ##*/
  public static QUOTE_STATUS_ARRAY = [
    {
      name: 'All',
      class: '',
      status: [],
      label_class: '',
      disable_class: '',
      color: '',
      background: ''
    },
    {
      name: 'Quote Created',
      formatted_name: 'Quote<br>Created',
      class: 'quote',
      status: ['QC'],
      label_class: 'quote-flag',
      disable_class: 'quote-disable',
      color: '#9A5FA8',
      background: '#9A5FA8'
    },
    {
      name: 'Auto Delivery Quote Applied',
      formatted_name: 'Auto Delivery<br>Quote Applied',
      color: '#499D63',
      class: 'auto-delivery-quote-applied',
      status: ['ADQAP'],
      label_class: 'auto-delivery-quote-applied-flag',
      disable_class: 'applied-disable',
      background: '#499D63'
    },
    {
      name: 'Delivery Address Required',
      class: 'delivery-address-required',
      status: ['DAR'],
      label_class: 'delivery-address-required-flag',
      disable_class: 'delivery-address-required-disable',
      background: '#D42A3B',
      color: '#D42A3B',
      formatted_name: 'Delivery Address<br>Required',
    },
    {
      name: 'Manual Delivery Quote Required',
      class: 'manual-delivery-quote-required',
      status: ['MDQR'],
      label_class: 'manual-delivery-quote-required-flag',
      disable_class: 'pending-disable',
      background: '#D42A3B',
      color: '#D42A3B',
      formatted_name: 'Manual Delivery<br>Quote Required',
    },
    {
      name: 'Manual Delivery Quote Pending',
      class: 'manual-delivery-quote-pending',
      status: ['MDQP'],
      label_class: 'manual-delivery-quote-charge-pending-flag',
      disable_class: 'pending-disable',
      background: '#D42A3B',
      color: '#D42A3B',
      formatted_name: 'Manual Delivery<br>Quote Pending',
    },
    {
      name: 'Manual Delivery Quote Added',
      class: 'manual-delivery-quote-added',
      status: ['MDQAD'],
      label_class: 'manual-delivery-quote-added-flag',
      disable_class: 'added-disable',
      background: '#6D709A',
      color: '#6D709A',
      formatted_name: 'Manual Delivery<br>Quote Applied',
    },
    {
      name: 'Manual Delivery Quote Applied',
      color: '#499D63',
      class: 'manual-delivery-quote-applied',
      status: ['MDQAP'],
      label_class: 'manual-delivery-quote-applied-flag',
      disable_class: 'applied-disable',
      background: '#499D63',
      formatted_name: 'Manual Delivery<br>Quote Applied',
    },
    {
      name: 'Follow Up',
      formatted_name: 'Follow<br>Up',
      color: '#6D709A',
      class: 'followup',
      status: ['FU'],
      label_class: 'followup-flag',
      disable_class: 'follow-up-disable',
      background: '#6D709A'
    },
    {
      name: 'Quote Accepted',
      formatted_name: 'Quote<br>Accepted',
      color: '#362E9B',
      class: 'quote-accepted',
      status: ['QA'],
      label_class: 'quote-accepted-flag',
      disable_class: 'quote-accepted-disable',
      background: '#362E9B'
    },
    {
      name: 'Deposit Payment Due',
      formatted_name: 'Deposit<br>Payment Due',
      class: 'deposit-payment-due',
      status: ['DPDU'],
      label_class: 'pending-flag',
      disable_class: 'deposit-pending-disable',
      background: '#3D95ED',
      color: '#3D95ED'
    },
    {
      name: 'Expired',
      formatted_name: 'Expired',
      class: 'expired',
      color: '#D42A3B',
      status: ['EXP'],
      label_class: 'expired-flag',
      disable_class: 'expired-disable',
      background: '#D42A3B'
    },
    {
      name: 'Archived',
      color: '#919192',
      status: ['QARCH'],
      label_class: 'archive-flag',
      background: 'none'
    }
  ];
  /*## Quote Status Constant ##*/

  /*## Order Status Constant ##*/
  public static ORDER_STATUS_ARRAY = [
    {
      name: 'All',
      class: '',
      status: [],
      label_class: '',
      disable_class: '',
      color: '',
      background: ''
    },
    {
      name: 'Order Received',
      class: 'received',
      status: ['OR'],
      label_class: 'recived-flag',
      email_template_key: ['order-received', 'deposit-paid'],
      formatted_name: 'Order<br>Received',
      disable_class: 'order-received-disable'
    },
    {
      name: 'In Production',
      color: '#4EBAB6',
      status: ['IP'],
      label_class: 'production-flag',
      formatted_name: 'In<br>Production',
      disable_class: 'in-production-disable'
    },
    {
      name: 'In Transit',
      class: 'transit',
      status: ['IT'],
      label_class: 'transit-flag',
      email_template_key: ['in-transit'],
      formatted_name: 'In<br>Transit',
      disable_class: 'in-transit-disable'
    },
    {
      name: 'Customs Held',
      color: '#499D63',
      status: ['CC'],
      label_class: 'cleared-flag',
      formatted_name: 'Customs<br>Held',
      disable_class: 'custom-held-disable'
    },
    {
      name: 'Available At Warehouse',
      class: 'packing',
      status: ['AAW'],
      label_class: 'packaging-flag',
      email_template_key: ['stock-landed'],
      formatted_name: 'Available At<br>Warehouse',
      disable_class: 'available-at-warehouse-disable'
    },
    {
      name: 'Final Payment Outstanding',
      color: '#3D95ED',
      status: ['FPP'],
      label_class: 'final-payment-flag',
      email_template_key: ['final-payment-reminder'],
      formatted_name: 'Final Payment<br>Outstanding',
      disable_class: 'final-payment-pending-disable'
    },
    {
      name: 'Final Payment Paid',
      class: 'received',
      status: ['FPPD', 'FUPP'],
      label_class: 'final-payment-paid-flag',
      email_template_key: ['nominate-delivery-date'],
      formatted_name: 'Final Payment<br>Paid',
      disable_class: 'final-payment-paid-disable'
    },
    {
      name: 'Nominate Delivery Date',
      color: '#D42A3B',
      status: ['GDUNS'],
      class: 'goods-despatch-unspecified-flag',
      label_class: 'goods-despatch-unspecified-flag',
      email_template_key: [],
      formatted_name: 'Nominate Delivery<br>Date',
      disable_class: 'goods-despatched-unspecified-disable'
    },
    {
      name: 'Awaiting Delivery Booking',
      color: '#D42A3B',
      status: ['GDUNS'],
      class: 'goods-despatch-unspecified-flag',
      label_class: 'goods-despatch-unspecified-flag-specified-date',
      email_template_key: [],
      formatted_name: 'Awaiting Delivery<br>Booking',
      disable_class: 'goods-despatched-unspecified-disable'
    },
    {
      name: 'Scheduled for Delivery',
      color: '#499D63',
      status: ['GDA'],
      class: 'goods-despatch-accepted-flag',
      label_class: 'goods-despatch-accepted-flag',
      formatted_name: 'Scheduled for<br>Delivery',
      disable_class: 'goods-despatched-accepted-disable'
    },
    {
      name: 'Goods Despatched',
      color: '#499D63',
      status: ['GD'],
      class: 'goods-despatched-flag',
      label_class: 'goods-despatched-flag',
      email_template_key: ['order-dispatched'],
      disable_class: 'goods-despatched-confirmed-disable'
    },
    {
      name: 'Goods Despatch Delivered',
      color: '#499D63',
      status: ['GDDE'],
      class: 'goods-despatch-delivered-flag',
      label_class: 'goods-despatched-delivered-flag',
      formatted_name: 'Goods Despatch<br>Delivered',
      disable_class: 'goods-despatched-delivered-confirmed-disable'
    },
    {
      name: 'Goods Despatch Client Organized',
      color: '#499D63',
      status: ['GDCO'],
      class: 'goods-despatched-client-organized-flag',
      label_class: 'goods-despatched-client-organized-flag',
      email_template_key: [],
      formatted_name: 'Goods Despatch<br>Client Organized',
      disable_class: 'goods-despatched-client-organized-disable'
    },
    {
      name: 'Complete',
      class: 'complete',
      status: ['C'],
      label_class: 'completed-flag',
      email_template_key: ['order-complete'],
      disable_class: 'complete-disable'
    }
  ];
  /*## Order Status Constant ##*/

  public static CONTACT_US_CONSTANTS = {
    SUCCESSFULLY: 'Thank you for filling out your information!',
    ERROR: 'Contact after some time',
  };

  public static ORDER_DELIVERY_DATE_FORM = {
    MAIN_HEADING: 'Add Stock Required Date',
    LABEL: 'Stock Required Date',
    REQUIRED_ERROR_MESSAGE: 'Please select stock required date',
    EDIT_MAIN_HEADING: 'Edit Stock Required Date',
  }

  public static STOCK_REQUIRE_DATE_UPDATE_ORDER = {
    ADD: "Stock required date has been added.",
    UPDATE: "Stock required date has been updated.",
  }

  public static FAQ_LISTS = {
    ARTICLE_PAGE: '1',
    HELP_CENTER_PAGE: '2',
    THE_GATHER_COMMITMENT_PAGE: '3',
    SAMPLES_PAGE: '4',
    CONTACTS_US_PAGE: '5',
    ACCOUNT_ORDER_PAGE: '6',
    ACCOUNT_QUOTE_PAGE: '7',
    ACCOUNT_GATHER_COMMITMENT_PAGE: '8',
    ACCOUNT_SAMPLES_PAGE: '9',
    DASHBOARD_PAGE: '10'
  }

  public static GROUT_COLOUR_TYPES = {
    TYPE_FG: "FG",
    TYPE_WJ: "WJ"
  }

  public static GROUT_COLOUR_PRODUCT_LINK = {
    FG: "https://ardexaustralia.com/product/ardex-fg-8/",
    WJ: "https://ardexaustralia.com/product/ardex-wj-50/"
  }
  public static BPAY_INFO_DESCRIPTION = `To ensure this transaction is promptly processed, please be sure to upload your payment remittence via the "Okay, I' ve Paid" button below.`;
  public static RESOURCE_CATEGORIES = {
    CATEGORY_TIPS_FOR_INSTALLATION: "Tips for Installation",
    CATEGORY_SUPPLY_PARTNERS: "Supply Partners",
    CATEGORY_SEALING_PROCEDURES: "Sealing Procedures",
    CATEGORY_MAINTENANCE_GUIDE: "Maintenance Guide",
    CATEGORY_SEALING_PROCEDURE: "Sealing Procedure",
  }

  public static GATHERCO = {
    ABN_NUMBER: '65 601 533 144',
    ADDRESS: 'Sydney - AUSTRALIA',
    CONTACT_NUMBER: '1800 428 437',
    EMAIL_ADDRESS: 'hi@gatherco.com.au',
    INFO: '@gathercoaustralia',
  }

  public static WAREHOUSE_COLLECTION_ADDRESS = {
    ADDRESS_LINE_1: '89 Fairey Road',
    ADDRESS_LINE_2: '',
    SUBURB: 'South Windsor',
    TOWN_CITY: 'Hawkesbury City Council',
    STATE_REGION: 'NSW',
    POST_CODE: '2756',
    COUNTRY: 'Australia',
  }

  public static QUOTE_ORDER_MESSAGE_CONSTANTS = {
    PRODUCT_REMOVE: "Product has been removed from quote.",
    PRODUCT_RESTRICTION_FOR_LAST_PRODUCT: "You cannot delete the last product from sample order.",
    QUOTE_PRODUCT_RESTRICTION_FOR_LAST_PRODUCT: "You cannot delete the last product from quote.",
    QUOTE_ORDER_REMOVE: "Quote/Order deleted.",
    QUOTE_REMOVE: "Quote has been removed.",
    ORDER_REMOVE: "Order deleted.",
  }

  public static CONSUMABLE_CALCULATOR_CONSTANTS = {
    TYPE_ADHESIVE: `Laticrete 335 Adhesive`,
    TYPE_DEFENDER: `Actichem CSD Defender`,
    TYPE_GOLD: `Actichem Solv Sealer Gold`,
    ADDED_TO_QUOTE_SUCCESS_MESSAGE: `Selected item successfully added to your quote.`,
    ADDED_TO_QUOTE_ERROR_MESSAGE: `Selected item successfully not added to your quote`,
    REMOVED_FROM_QUOTE_SUCCESS_MESSAGE: `Selected item successfully removed from your quote.`,
    REMOVED_FROM_QUOTE_ERROR_MESSAGE: `Selected item successfully not removed from your quote.`,
  }

  public static ADD_CONSUMABLE_CALCULATOR_AFTER_CREDIT_APPLIED = {
    BODY_MESSAGE: 'Your applied credit will be removed. Are you sure you want add this consumable calculator?',
  }

  public static REMOVE_CONSUMABLE_CALCULATOR_AFTER_CREDIT_APPLIED = {
    BODY_MESSAGE: 'Your applied credit will be removed. Are you sure you want removed this consumable calculator?',
  }

  public static ADD_PRODUCT_AFTER_CREDIT_APPLIED = {
    BODY_MESSAGE: 'Your applied credit will be removed. Are you sure you want add this product?',
  }

  public static UPDATE_PRODUCT_QUANTITY_AFTER_CREDIT_APPLIED = {
    BODY_MESSAGE: 'Your applied credit will be removed. Are you sure you want update the quantity of this product?',
  }

  public static UPDATE_PRODUCT_QUANTITY_AFTER_DELIVERY_CHARGE_ADDED = {
    BODY_MESSAGE: 'This quote has already had a manual delivery fee calculated. Proceeding with further edits will require a new delivery fee to be manually applied. Do you still want to continue?',
  }

  public static DELETE_PRODUCT_AFTER_CREDIT_APPLIED = {
    BODY_MESSAGE: 'Your applied credit will be removed. Are you sure you want delete this product?',
  }

  public static DELETE_PRODUCT_AFTER_DELIVERY_CHARGE_ADDED = {
    BODY_MESSAGE: 'This quote has already had a manual delivery fee calculated. Proceeding with further edits will require a new delivery fee to be manually applied. Are you sure you want delete this product?',
  }

  public static IS_WAREHOUSE_COLLECTION_YES = 'Y';
  public static IS_WAREHOUSE_COLLECTION_NO = 'N';

  public static IS_DEFAULT_BUSINESS_ADDRESS_YES = 'Y';
  public static IS_DEFAULT_BUSINESS_ADDRESS_NO = 'N';

  public static IS_USED_OWN_TRANSPORT_NO = 'N';

  public static UPLOAD_PDF = {
    UPLOAD_PDF_TYPE_VALIDATION_MESSAGE: 'Please upload PDF only',
    UPLOAD_PDF_SIZE_VALIDATION: 'Please upload less than 40 MB file'
  }

  public static MULTI_UPLOAD_FILE = {
    UPLOAD_FILE_TYPE_VALIDATION_MESSAGE: 'Only files with the following extensions are allowed: jpg, jpeg, png, and pdf.',
    UPLOAD_FILE_TYPE_VALIDATION_MESSAGE_PARTIAL_PAYMENT: 'Only images and PDF files are allowed.',
    UPLOAD_FILE_SIZE_VALIDATION: 'Please upload less than 40 MB file'
  }

  public static SUCCESS_MESSAGE_ON_PAYMENT_RECEIPT_UPLOAD = 'Payment remittance has been uploaded.';
  public static PARTIAL_PAYMENT_RECEIPT_REQUIRED = 'Please select file.';
  public static ERROR_MESSAGE_ON_PAYMENT_RECEIPT_UPLOAD = 'Error while uploading payment remittance.';

  public static ALLOWED_UPLOAD_SIZE_MB_PDF = 40;
  public static CREDIT_CARD_MERCHANT_SERVICE_FEE_FOR_DOMESTIC = 1.87;
  public static CREDIT_CARD_MERCHANT_SERVICE_FEE_FOR_INTERNATIONAL = 2.97;
  public static CREDIT_CARD_TRANSACTION_FEE = 0.33;

  public static IS_DEPOSIT_PAYMENT_PROCESSING_YES = 'Y';

  public static IS_FINAL_PAYMENT_PROCESSING_YES = 'Y';

  public static IS_FULL_PAYMENT_PROCESSING_YES = 'Y';

  //Payment Status Message
  public static REMAINING_BALANCE = 'Remaining Balance';
  public static FULL_PAYMENT_DUE = 'Full Payment Due';
  public static FINAL_PAYMENT_DUE = 'Final Payment Due';
  public static FINAL_PAYMENT_REMAINING = 'Final Payment Remaining';
  public static DEPOSIT_PAYMENT_DUE = 'Deposit Payment Due';
  public static PAYMENT_PROCESSING = 'Payment Processing';
  public static SITE_CONTACT_INFORMATION_UPDATED = 'Site contact information has been updated.'
  public static DELIVERY_ADDRESS_UPDATED = 'Delivery address has been updated.'
  public static ORDER_TYPE_QUOTE_SHORT = 'Q';
  public static ORDER_TYPE_ORDER_SHORT = 'O';
  public static DEPOSIT_PAYMENT_PROCESSING = 'Deposit Payment Processing';
  public static DEPOSIT_PAYMENT_IMMINENT = ' Deposit Expiry Imminent';

  public static DELIVERY_INSTRUCTION_UPDATE = 'Delivery instruction has been updated.'
  public static DELIVERY_INSTRUCTION_ADDED = 'Delivery instruction has been added.'

  public static ORDER_STATUS_DISPLAY_FOR_INVOICE_LINK = 'invoice_link';
  public static ORDER_STATUS_DISPLAY_FOR_TRACKING_LINK = 'tracking_link';

  public static IS_CONFIRM_STOCK_REQUIRED_DATE_YES = 'Y';
  public static IS_CONFIRM_STOCK_REQUIRED_DATE_NO = 'N';
  public static GOODS_DISPATCHED_MILESTONE_STATUS_ARRAY = ['GDUNS', 'GDOTT', 'GDA', 'GDD', 'GD', 'GDCO', 'GDDE', 'CAN', 'FU', 'C'];

  public static QUOTE_STATUS_FINAL_PAYMENT = 'Final Payment Pending';
  public static BADGE_TITLE_FINAL_PAYMENT_OUTSTANDING = 'Final Payment Outstanding';
  public static BADGE_TITLE_BALANCE_REMAINING = 'Balance Remaining';
  public static TRUCK_TYPE_CLIENT_ORGANIZED = 'Client Organized';

  public static TENTATIVE_STOCK_REQUIRED_DATE_LABEL = 'Tentative Stock Required Date';
  public static NOMINATE_DELIVERY_DATE_LABEL = 'Nominate Stock Required Date';
  public static STOCk_REQUIRED_DATE_CONFLICT_LABEL = 'Stock Required Date Conflict';
  public static FINAL_PAYMENT_REMAINING_LABEL = 'Final Payment Remaining';
  public static FINAL_PAYMENT_DUE_LABEL = 'Final Payment Due';
  public static PAYMENT_PROCESSING_LABEL = 'Payment Processing';
  public static DEPOSITE_PAYMENT_DUE_LABEL = 'Deposit Payment Due';
  public static TENTATIVE_QUOTE_STOCK_REQUIRED_DATE_LABEL = 'Tentative Stock Required Date Added';
  public static NOMINATE_QUOTE_DELIVERY_DATE_LABEL = 'Nominate Stock Required Date '
  public static QUOTE_EXPIRED = "Expired"

  public static STATUS_ALERT_MESSAGES = [
    {
      type: 'payment',
      className: 'final-payment-remaining',
      label: this.FINAL_PAYMENT_REMAINING_LABEL,
      message: 'Your order still has an outstanding balance. You’ll be notified once the final payment is due.'
    },
    {
      type: 'payment',
      className: 'final-payment-due',
      label: this.FINAL_PAYMENT_DUE_LABEL,
      message: 'The outstanding balance of your order is now due. It\'s important to note that all of our transport services are outsourced, meaning it typically takes around 5 working days to secure a truck booking. Our team will not commence the delivery booking process, until any owed sum has been paid in full. To avoid dispatching delays, please action this immediately.'
    },
    {
      type: 'payment',
      className: 'final-payment-remaining',
      label: this.PAYMENT_PROCESSING_LABEL,
      message: 'BPAY payments may take up to 3 business days to clear. Our team will endeavour to reduce this timeframe, but can only do so if you\'ve provided us with the applicable payment remittance. If you did not upload proof of payment as the final step in our checkout gateway, please send a copy to hi@gatherco.com.au'
    },
    {
      type: 'date',
      className: 'final-payment-remaining',
      label: this.TENTATIVE_STOCK_REQUIRED_DATE_LABEL,
      message: 'A tentative delivery date has been added to order. This is not set. A member of our despatching team will be in contact again for final confirmation before coordinating delivery. These icons and descriptions must appear on both the invoice live-links and corresponding tracking live-links. Customers must have the ability to apply SRD’s from both the invoice and tracking live links.'
    },
    {
      type: 'date',
      className: 'final-payment-due',
      label: this.NOMINATE_DELIVERY_DATE_LABEL,
      message: 'Please nominate your preferred delivery date. The date you specify is not confirmed. It simply allows our despatching team to apply the relevant level of priority to each order. A member of our despatching team be in contact again for final confirmation before coordinating delivery.'
    },
    {
      type: 'date',
      className: 'final-payment-due',
      label: this.STOCk_REQUIRED_DATE_CONFLICT_LABEL,
      message: 'The specified stock required date is not compatible with the anticipated availability of your order. Please nominate a new delivery date.'
    },
    {
      type: 'payment',
      className: 'deposite-payment-due',
      label: this.DEPOSITE_PAYMENT_DUE_LABEL,
      message: 'The deposit sum is now due. No order will be processed until your transaction has cleared. This payment gateway has an expiry period of 7 days.'
    },
    {
      type: 'payment',
      className: 'final-payment-remaining',
      label: this.DEPOSIT_PAYMENT_PROCESSING,
      message: 'BPAY payments may take up to 2 business days to clear. Our team will endeavour to reduce this timeframe, but can only do so if you\'ve provided us with the applicable payment remittance. If you did not upload proof of payment as the final step in our checkout gateway, please send a copy to hi@gatherco.com.au.'
    },
    {
      type: 'payment',
      className: 'deposite-payment-due',
      label: this.DEPOSIT_PAYMENT_IMMINENT,
      message: 'Your deposit payment is due and now less than 3 days from expiry. Stock is only ever secured or put into production, following payment of the applicable deposit sum. If you\'re still intending to proceed with this order, please take immediate action.'
    },
    {
      type: 'date',
      className: 'final-payment-remaining',
      label: this.TENTATIVE_QUOTE_STOCK_REQUIRED_DATE_LABEL,
      message: 'You have added a tentative stock required date to your quote. The nominated date is not confirmed. Should this order go ahead, we\'ll be in contact again for confirmation before coordinating delivery.'
    },
    {
      type: 'date',
      className: 'deposite-payment-due',
      label: this.NOMINATE_QUOTE_DELIVERY_DATE_LABEL,
      message: 'Please nominate your preferred stock required date. The date you specify is not confirmed. It simply allows our team to apply the relevant level of priority to each project. Should this order go ahead, we\'ll be in contact again for confirmation before coordinating delivery.'
    },
    {
      type: '',
      className: 'deposite-payment-due',
      label: this.QUOTE_EXPIRED,
      message: 'This quote has expired and is no longer valid. Please contact your assigned sales rep to request reactivation. Reactivated quotes are subject to all relevant price increases and stock availability.'
    }
  ];
  public static CLIENT_ORGANIZE_TOOLTIP_TITLE = 'Client Organized';
  public static CLIENT_ORGANIZE_TOOLTIP_MESSAGE = 'You have opted to facilitate your own transport. As such, the collection of this order is your responsibility to finance and coordinate. We kindly request written notice, no less than 3 working days prior to collection.';
  public static GOOGLE_REVIEW_LINK = 'https://g.page/r/CXIpGHQsWMdMEB0/review';
  public static WAREHOUSE_ARRIVAL_DATE_TOOLTIP_MESSAGE = 'Although we do everything possible to ensure accuracy, please note that this date is approximate only. Our team will notify you immediately of any delays.'
  public static LEAD_TIME_TOOLTIP_MESSAGE = 'This lead is a guide only and subject to change. Your assigned sales rep can provide further insight if the detail lead is not compatible with your established construction schedule.'
  public static PREVENT_DOWNLOAD_ERROR_MESSAGE = 'You need to sign in to download this. Please sign in to proceed.';
  public static PREVENT_ACCESS_PRICE_LIST_ERROR_MESSAGE = 'To access our price list, please log in to your account.';
  public static REQUEST_DELIVERY_QUOTE_TOOLTIP_MESSAGE = 'Once items for your quote are finalized, use this button to request a manual delivery quote. Further adjustment of items or quantities will require the applied delivery charge be re-quoted.';
  public static SITE_CONTACT_TOOLTIP_MESSAGE = 'This is the individual that you would like our despatching team to to coordinate delivery with.';
  public static WAREHOUSE_COLLECTION_TOOLTIP_MESSAGE = 'Select this option, if you intend to organise your own transport.';
  public static INSTRUCTION_TOOLTIP_MESSAGE = 'Please ensure that any detail relevant to the successful delivery of your order is outlined here.';
  public static CRATES_TOOLTIP_MESSAGE = 'Our collections are distributed in a variety of timber crate sizes. On average, their dimensions are: 1,100 x 1,100 x 800mm.';
  public static WEIGHT_TOOLTIP_MESSAGE = 'This is the total collective weight of your full order.';
  public static FLATBED_TRUCK_TOOLTIP_MESSAGE = 'Only select this option if an appropriate mechanical unloading device is present on site (either forklift or crane). Manual unloading is strictly forbidden. Penalties apply.';
  public static DELIVERY_TBC_TOOLTIP_MESSAGE = 'Transport must be manually calculated. Scroll to the bottom of this page to request a delivery quote.';
  public static APPLICABLE_DELIVERY_CHARGE_TOOLTIP_MESSAGE = 'The applicable delivery charge has been calculated. Further adjustment of items or quantities will require the applied delivery charge be re-quoted.';

  /*## Mega Menu Type ##*/
  public static FLOORING_TYPE_ID = 1;
  public static WALLING_TYPE_ID = 2;
  public static FLOORING_TYPE_NAME = 'flooring';
  public static WALLING_TYPE_NAME = 'walling';
  public static PRODUCT_TYPE_FLOORING_CONSTANTS = {
    TITLE: 'Flooring',
    DESCRIPTION: `The first step towards unique design is a solid foundation. Our natural stone flooring surfaces have been tried, tested, and celebrated throughout history; timeless options that can't be duplicated.
          <br><br>
          With a collection rich in character, versatility, and tactility, our job is to provide a surface that perfectly matches your vision. GatherCo offers a suite of options, each boasting distinct hues, textures, finishes, and versatile formats that can elevate and inspire your design.
          <br><br>
          Our range of flooring solutions and outdoor paving reflect our unwavering commitment to craftsmanship and creativity. From classic materials to avant-garde finishes, we offer a curated selection designed to inspire the imagination and bring visions to life.
          <br><br>
          Sourced from all corners of the globe, we are constantly unearthing new and exciting products, styles, and applications, ensuring GatherCo has a bespoke surface for any and every brief.`,
    MAIN_IMAGE_PATH: this.S3_PRODUCT_RESOURCE_IMAGE_KIT_URL + '/' + 'ASSETS/FLOORING/HERO_SECTION/flooring.jpg',
    SUB_IMAGE_PATH: this.S3_PRODUCT_RESOURCE_IMAGE_KIT_URL + '/' + 'ASSETS/FLOORING/HERO_SECTION/flooring-sub.webp'
  }
  public static PRODUCT_TYPE_WALLING_CONSTANTS = {
    TITLE: 'Walling',
    DESCRIPTION: `Our natural stone walling collection tells a tale as old as time itself - raw natural beauty honed over thousands of years. GatherCo delivers options that will elevate your design with a unique, aged distinction, tapping into the imperfections and irregularities of stone’s organic texture; our range adds depth and character to any project.
          <br><br>
          Focusing on materials that are easy to install and specify, the GatherCo natural stone walling and cladding collection is ideal for residential and commercial builds that prioritise ease without wanting to sacrifice quality. Whether adorning interior spaces, feature wall tiles or enhancing outdoor environments, our curated selection of walling options provides endless design possibilities, inviting creativity and innovation in every application.
          <br><br>
          Sourced from bespoke suppliers around the world, we offer new and unique natural stone options guaranteed to fit any brief.`,
    MAIN_IMAGE_PATH: this.S3_PRODUCT_RESOURCE_IMAGE_KIT_URL + '/' + 'ASSETS/WALLING/HERO_SECTION/walling.jpg',
    SUB_IMAGE_PATH: this.S3_PRODUCT_RESOURCE_IMAGE_KIT_URL + '/' + 'ASSETS/WALLING/HERO_SECTION/walling-sub.webp'
  }

  public static PRODUCT_DISCOUNT_PERCENTAGE = 10;
  public static USED_FOR_FAMILY_DROPDOWN = 1;
  public static USED_FOR_ADDITIONAL_FAMILY_SECTION = 2;

  public static DOWNLOAD_SUCCESSFULLY = 'Download successful';
  public static DOWNLOAD_FAILED = 'Download failed. Please enable popups and try again.';

  public static UNABLE_TO_FETCH_USER_DETAIL = 'Failed to fetch user details.'
  public static UNABLE_TO_FETCH_CREDIT_DETAIL = 'Failed to fetch credit details.'
  public static RRP_TOOLTIP = 'Although we offer direction on RRP, GatherCo\'s rates are all Trade.';
  public static TRADE_MEMBER_ACCESS = 'This content is available exclusively for Trade members.'
  public static SOCIAL_MEDIA_URLS = {
    FACEBOOK: 'https://www.facebook.com/gathercoaustralia/',
    INSTAGRAM: 'https://www.instagram.com/gathercoaustralia/',
    PINTEREST: 'https://www.pinterest.com.au/gathercoaus/'
  };
  public static AUTH_MODAL_TYPES = {
    LOGIN: 'login',
    REGISTER: 'register',
    RESET_PASSWORD: 'reset-password',
    CHANGE_PASSWORD: 'change-password',
  }
  public static MODAL_TYPES = {
    FINISH: 'finish',
    SLIP_RATING: 'slip-rating',
    TEXTURE_GUIDE: 'texture-guide',
    COLOUR_VARIATION: 'colour-variation',
    SEAMLESS_TEXTURE: 'seamless-texture',
    IMAGES: 'images',
    EDGE: 'edge',
    COPING: 'coping',
    ADHESIVE_SEALING: 'adhesive-sealing',
    PRODUCT_IMAGES: 'product-images',
    ADD_PRODUCT: 'add-product',
    PAYMENT_RECEIPT: 'payment-receipt',
    CORNER: 'corner',
  }
  public static MAX_SHOW_PRODUCT = 8
  public static WASTAGE_TYPES = [
    {percentage: 10, name: '10% Wastage'},
    {percentage: 15, name: '15% Wastage'},
    {percentage: 20, name: '20% Wastage'},
  ]
  public static EDGE_DETAILS = {
    description: 'Through close collaboration with our network of supply quarries, we’ve thoughtfully curated a comprehensive collection of edge profiles. The specifications provided here are not  options for selection; they are intended as indicative representations, showcasing the distinctive qualities and design potential of each profile.',
    data: [
      {
        image: '/ASSETS/PRODUCT/EDGES/GatherCo_DistressedEdge.webp',
        title: 'Distressed Edge',
        value: 'distressed',
        description: 'Distressed Edge creates a worn, vintage look by adding intentional imperfections.'
      },
      {
        image: '/ASSETS/PRODUCT/EDGES/GatherCo_HeavilyDistressedEdge.webp',
        title: 'Heavily Distressed Edge',
        value: 'heavily_distressed',
        description: 'Heavily Distressed Edge features pronounced wear and tear for an intense, aged effect.'
      },
      {
        image: '/ASSETS/PRODUCT/EDGES/GatherCo_SawnEdge.webp',
        title: 'Sawn Edge',
        value: 'sawn',
        description: 'Sawn Edge has a rough, unfinished appearance from being cut with a saw.'
      },
      {
        image: '/ASSETS/PRODUCT/EDGES/GatherCo_SicilianEdge.webp',
        title: 'Sicilian Edge',
        value: 'sicilian',
        description: 'Sicilian Edge features a clean, refined look with straight, smooth edges that are carefully shaped for a polished finish.'
      },
      {
        image: '/ASSETS/PRODUCT/EDGES/GatherCo_SplitEdge.webp',
        title: 'Split Edge',
        value: 'split',
        description: 'Split Edge features a jagged or uneven finish from being split or fractured.'
      },
      {
        image: '/ASSETS/PRODUCT/EDGES/GatherCo_TumbledEdge.webp',
        title: 'Tumbled Edge',
        value: 'tumbled',
        description: 'Tumbled Edge has a smooth, rounded finish from being worn down or polished.'
      }
    ]
  };

  public static COPING_PROFILE_DETAILS = {
    description: 'In collaboration with our network of supply quarries, we’ve meticulously crafted a versatile collection of coping profiles. The specifications provided here aren’t options for selection; rather, they serve as indicative representations, illustrating the unique characteristics of each profile in form and function.',
    data: [
      {
        image: '/ASSETS/PRODUCT/COPING_PROFILES/GatherCo_Coping_SquareEdgeProfile_30mm.webp',
        title: 'Square Edge (30mm Thick)',
        description: 'A  contemporary coping solution with defined lines, ideal for achieving a modern aesthetic while ensuring durability and precise alignment in pool designs.',
        key: 'Square Edge',
        size: '30mm',
        accessoryProfileImage: '/ICONS/Formats/GatherCo_FormatIcon_Accessory_Coping_SquareEdge.svg'
      },
      {
        image: '/ASSETS/PRODUCT/COPING_PROFILES/GatherCo_Coping_SquareEdgeProfile_50mm.webp',
        title: 'Square Edge (50mm Thick)',
        description: 'A robust coping option designed for enhanced visual impact and structural integrity, perfect for projects requiring a bold, exaggerated edge profile.',
        key: 'Square Edge',
        size: '50mm',
        accessoryProfileImage: '/ICONS/Formats/GatherCo_FormatIcon_Accessory_Coping_SquareEdge.svg'
      },
      {
        image: '/ASSETS/PRODUCT/COPING_PROFILES/GatherCo_Coping_CalibreatedEdgeProfile.webp',
        title: 'Calibrated Edge',
        description: 'A precision-crafted coping option designed for seamless installation, offering a uniformed thickness profile at the exposed edge.',
        key: 'Calibrated Edge',
        size: 'any',
        accessoryProfileImage: '/ICONS/Formats/GatherCo_FormatIcon_Accessory_Coping_CalibratedEdge.svg'
      },
      {
        image: '/ASSETS/PRODUCT/COPING_PROFILES/GatherCo_Coping_DropEdgeProfile.webp',
        title: 'Drop Edge',
        description: 'A practical yet elegant coping solution featuring an exaggerated pool-facing edge thickness, simplifying installation by removing the need to adjust for set downs between the coping tile and surrounding tile body',
        key: 'Dropdown',
        size: 'any',
        accessoryProfileImage: '/ICONS/Formats/GatherCo_FormatIcon_Accessory_Coping_DropDown.svg'
      },
      {
        image: '/ASSETS/PRODUCT/COPING_PROFILES/GatherCo_Coping_CrazyPavingProfile.webp',
        title: 'Crazy Paving Edge',
        description: 'A versatile yet practical coping solution designed to complement organic, freeform designs, offering a natural aesthetic that seamlessly integrates with irregular paving styles.',
        key: 'Crazy Paving',
        size: 'any',
        accessoryProfileImage: '/ICONS/Formats/GatherCo_FormatIcon_Accessory_Coping_CrazyPaving.svg'
      },
      {
        image: '/ASSETS/PRODUCT/COPING_PROFILES/GatherCo_Coping_BullnoseProfile_30mm.webp',
        title: 'Bullnose Edge',
        description: 'A timeless coping option with a rounded profile, providing a smooth and elegant finish that enhances safety and complements both classic and modern pool designs.',
        key: 'Bullnose',
        size: 'any',
        accessoryProfileImage: '/ICONS/Formats/GatherCo_FormatIcon_Accessory_Coping_Bullnose.svg'
      },
      {
        image: '/ASSETS/PRODUCT/COPING_PROFILES/GatherCo_Coping_SquareEdgeProfile_30mm.webp',
        title: 'Double Pencil Round Edge',
        description: 'A refined coping option with a subtle, dual-rounded profile that delivers a sophisticated finish, ideal for projects requiring a smooth, seamless transition between the pool and surrounding surfaces.',
        key: 'Double Pencil Edge',
        size: 'any',
        accessoryProfileImage: '/ICONS/Formats/GatherCo_FormatIcon_Accessory_Coping_DoublePencilRound.svg'
      }
    ]
  };

  public static CORNER_PROFILE_DETAILS = {
    description: 'Corner pieces are an essential element of any quality walling installation, ensuring seamless transitions between surfaces and creating the appearance of a solid stone wall. Designed for authenticity and architectural integrity, our collection highlights the unique qualities of natural stone, enhancing the overall aesthetic of the installation.',
    data: [
      {
        image: '/ASSETS/PRODUCT/CORNER_PROFILES/GatherCo_CornerPiece_NaturalLayWalling-7.webp',
        title: 'Block Face Walling Corner Piece',
        description: 'Engineered for seamless integration with our Block Face Walling system, this corner piece provides a robust and authentic look. Designed to replicate the natural characteristics of hand-cut stone blocks, it ensures a flawless transition around corners, enhancing the overall integrity and aesthetic of the installation. Perfect for architects and builders seeking a classic yet refined finish for exterior walls.',
        key: 'Block Face Walling Corner Piece',
        size: 'any',
        accessoryProfileImage: '/ICONS/Formats/GatherCo_FormatIcon_Accessory_Corner_BlockFace.svg'
      },
      {
        image: '/ASSETS/PRODUCT/CORNER_PROFILES/GatherCo_CornerPiece_SlenderSplitWalling-2.webp',
        title: 'Natural Lay Walling Corner Piece',
        description: 'Crafted to complement the irregular contours of our Natural Lay Walling system, this corner piece ensures a seamless and authentic transition around edges. Its organically shaped design mirrors the natural randomness of raw stone, delivering a rustic yet sophisticated finish. Ideal for projects aiming to showcase the unrefined beauty of organic stonework while maintaining structural precision.',
        key: 'Natural Lay Walling Corner Piece',
        size: 'any',
        accessoryProfileImage: '/ICONS/Formats/GatherCo_FormatIcon_Accessory_Corner_NaturalLay.svg'
      },
      {
        image: '/ASSETS/PRODUCT/CORNER_PROFILES/GatherCo_CornerPiece_StraighEdgeWalling-2.webp',
        title: 'Slender Split Walling Corner Piece',
        description: 'Designed to enhance the streamlined aesthetic of our Slender Split Walling system, this corner piece features a narrow, elongated profile that creates a striking linear effect. Perfect for projects emphasizing clean, horizontal lines, it ensures seamless transitions around corners while maintaining the natural character of split stone. This corner piece is ideal for achieving a contemporary look with a touch of organic texture.',
        key: 'Slender Split Walling Corner Piece',
        size: 'any',
        accessoryProfileImage: '/ICONS/Formats/GatherCo_FormatIcon_Accessory_Corner_SlenderSplit.svg'
      },
      {
        image: '/ASSETS/PRODUCT/CORNER_PROFILES/GatherCo_CornerPiece_StraightEdgeWalling-2.webp',
        title: 'Straight Edge Walling Corner Piece',
        description: 'Designed to pair flawlessly with our Straight Edge Walling system, this corner piece features clean, squared, and rectangular edges for a refined yet natural aesthetic. It ensures crisp, precise transitions around corners while maintaining the organic appeal of stonework. Perfect for projects that require a balance of structured geometry and timeless stone textures, providing a polished and professional finish.',
        key: 'Straight Edge Walling Corner Piece',
        size: 'any',
        accessoryProfileImage: '/ICONS/Formats/GatherCo_FormatIcon_Accessory_Corner_StraightEdge.svg'
      }
    ]
  };

  public static CUSTOMER_RATING_REVIEW = [
    {
      name: "Caleb Moore",
      review: "We’ve been sourcing stone products from GatherCo for the past six years, and their quality and consistency have never failed to impress us. Their wide selection and premium materials have been a cornerstone in many of our projects, allowing us to achieve the aesthetic and durability our clients expect. The team at GatherCo is always responsive, knowledgeable, and ready to assist with any inquiries or custom requests we have. GatherCo has continually provided reliable and timely service, keeping our projects on track and up to our high standards. If you’re looking for a stone supplier who delivers on quality and service, we highly recommend GatherCo.",
      avatarInitial: "CM",
      avatarBackgroundColor: "#FFD700"
    },
    {
      name: "Jacqueline Butler",
      review: "Love dealing with Gather and Co, they are very responsive and professional. Their service providing samples and quotes has been great with all of my projects to date. The products are looking amazing on-site also.",
      avatarInitial: "JB",
      avatarBackgroundColor: "#FF6347"
    },
    {
      name: "Brent Fitzpatrick",
      review: "I have specified GatherCo for multiple hospitality and residential projects over the past four years. The team consistently communicates well regarding stock availability, delivery dates, and any necessary rectifications for defects. I love their products so much that I have also used them extensively throughout my own home.",
      avatarInitial: "BF",
      avatarBackgroundColor: "#4682B4"
    },
    {
      name: "Cy Lynchwoodlock",
      review: "Really great company to deal with. Correspondence has been very professional, and I was kept up to date with lead times and deliveries.",
      avatarInitial: "CL",
      avatarBackgroundColor: "#32CD32"
    },
    {
      name: "Thomas Cormoreche",
      review: "Great operations orchestrated by caring humans. Dealing with these guys is always a pleasure; the proactivity is invaluable. The website is simply state-of-the-art. What else to say? Hoping these praises don't lead to a price increase. 😉",
      avatarInitial: "TC",
      avatarBackgroundColor: "#FF4500"
    },
    {
      name: "James Shaw-Taylor",
      review: "Incredibly happy with our experience with GatherCo. Their communication and attention to detail throughout the project were fantastic. The first thing everyone says when they walk into our home is how amazing the handmade terracotta floors are. Thanks, guys, for a wonderful experience. We love our floors!",
      avatarInitial: "JS",
      avatarBackgroundColor: "#6A5ACD"
    },
    {
      name: "William Dangar",
      review: "Our organisation (Dangar Barin Smith) works closely with the GatherCo team across many of our projects. They have an unprecedented enthusiasm and always go above and beyond to assist us in sourcing product outside their standard offering. I would highly recommend both the service and product to any potential industry client.",
      avatarInitial: "WD",
      avatarBackgroundColor: "#FF69B4"
    },
    {
      name: "John Khamis",
      review: "The team at GatherCo were amazing in helping us with our stone work. Great job from start to finish. Highly recommend.",
      avatarInitial: "JK",
      avatarBackgroundColor: "#8B0000"
    },
    {
      name: "Trystan Graham",
      review: "Have dealt with this hardworking team on multiple projects, of which they have gone above and beyond. Highly recommended.",
      avatarInitial: "TG",
      avatarBackgroundColor: "#20B2AA"
    },
    {
      name: "Charlie Albone",
      review: "GatherCo has the best range of products and always jumps to help us at Inspired Exteriors.",
      avatarInitial: "CA",
      avatarBackgroundColor: "#FF7F50"
    },
    {
      name: "Eden Triffitt",
      review: "Been in the building industry for 20 years and one the best suppliers I have dealt with, amazing products and service is phenomenal.",
      avatarInitial: "ET",
      avatarBackgroundColor: "#5096ff"
    },
    {
      name: "Karl Russo",
      review: "Always incredible customer service! Couldn't recommend highly enough, Beautiful stone, very happy with the outcome.",
      avatarInitial: "KR",
      avatarBackgroundColor: "#399c10"
    }
  ];

  public static PP_COLLECT_INFO_ID = 'collect-info'
  public static PP_PROCESS_INFO_ID = 'process-info'
  public static PP_SHARE_INFO_ID = 'share-info'
  public static PP_COOKIE_TRACK_ID = 'cookie-tracking'
  public static PP_KEEP_LONG_INFO_ID = 'keep-info-duration'
  public static PP_KEEP_SAFE_INFO_ID = 'keep-info-safe'
  public static PP_COLLECT_MINORS_INFO_ID = 'minors-info'
  public static PP_PRIVACY_RIGHTS_ID = 'privacy-rights'
  public static PP_NOT_TRACK_ID = 'do-not-track'
  public static PP_UPDATE_NOTICE_ID = 'update-notice'
  public static PP_CONTACT_NOTICE_ID = 'contact-info'
  public static PP_CRUD_INFO_ID = 'review-update-delete-data'

  public static PLACEHOLDER_IMAGE_PATH = 'https://ik.imagekit.io/gatherco/ASSETS/GENERAL/placeholder.png'
  public static VIDEO_PATH = {
    HOME_PAGE_VIDEO_IMAGE: '/ASSETS/VIDEOS/HOME/banner.png?tr=q-100,f-webp,e-sharpen-50',
    HOME_PAGE_VIDEO_PATH: 'https://gatherco.s3.ap-southeast-2.amazonaws.com/ASSETS/VIDEOS/HOME/gatherco-video.webm',
    PREMIUM_SEALER_VIDEO_IMAGE: '/VIDEOS/PRODUCT/background_image.webp',
    PREMIUM_SEALER_VIDEO_PATH: 'https://gatherco.s3.ap-southeast-2.amazonaws.com/ASSETS/VIDEOS/PRODUCT/premium_sealant_procedure.mp4',
    OUR_STORY_PAGE_VIDEO_IMAGE: 'https://ik.imagekit.io/gatherco/ASSETS/VIDEOS/ABOUT_US/gatherco-banner.png',
    OUR_STORY_PAGE_VIDEO_PATH: 'https://gatherco.s3.ap-southeast-2.amazonaws.com/ASSETS/VIDEOS/ABOUT_US/GatherCo_Our_Story.mp4',
  };

  public static SAMPLE_REQUEST_ASSETS = {
    PLACEHOLDER_IMAGE: 'https://ik.imagekit.io/gatherco/ASSETS/VIDEOS/SAMPLE_REQUEST/placeholder.png?tr=q-100,f-webp,e-sharpen-50',
    BEFORE_LOGIN_VIDEO_URL: 'https://gatherco.s3.ap-southeast-2.amazonaws.com/ASSETS/VIDEOS/SAMPLE_REQUEST/sample-unboxing.mp4',
    VIDEO_URL: 'https://gatherco.s3.ap-southeast-2.amazonaws.com/ASSETS/VIDEOS/SAMPLE_REQUEST/SAMPLE REQUEST v2.mp4',
    VIDEO_URL_PLACEHOLDER_IMAGE: 'https://ik.imagekit.io/gatherco/ASSETS/VIDEOS/HOME/gatherco-banner.png'
  };

  public static INFORMATION_TYPE = {
    COMPANY: 'company',
    PERSONAL: 'personal'
  }

// Account Setting constant
  public static ACCOUNT_TYPE_HOME: 'home' = 'home';
  public static ACCOUNT_TYPE_BUSINESS: 'business' = 'business';

  public static DEACTIVATE_TITTLE = 'Deactivate Account'
  public static DEACTIVATE_MESSAGE = ' Your account deactivation request has been submitted, A member of our team will contact you shortly to finalize the process.'

  public static UNSUBSCRIBE_NEWS_LETTER_TITLE = 'Unsubscribe from Newsletter';
  public static UNSUBSCRIBE_NEWS_LETTER_MESSAGE = 'Are you sure you want to unsubscribe from our newsletter? You will no longer receive updates or offers from us.';
  public static UNSUBSCRIBE_NEWS_LETTER_SUCCESS_MESSAGE = 'You have successfully unsubscribed from the newsletter.';

  public static SUBSCRIBE_NEWS_LETTER_TITLE = 'Subscribe from Newsletter.';
  public static SUBSCRIBE_NEWS_LETTER_MESSAGE = 'Are you sure you want to subscribe to our newsletter? You will start receiving updates and offers from us.';
  public static SUBSCRIBE_NEWS_LETTER_SUCCESS_MESSAGE = 'You have successfully subscribed to the newsletter.';

  public static NEWS_LETTER_SUBSCRIBE = {
    SUBSCRIBE: 1,
    UNSUBSCRIBE: 0,
  }
  public static PROFILE_PICTURE_UPLOAD_SUCCESS = 'Your profile picture has been successfully uploaded!';
  public static FAILED_TO_UPLOAD_PROFILE_PICTURE = 'Oops! There was an error while uploading your profile picture. Please try again.';
  public static INVALID_IMAGE_TYPE = 'Please select a valid image file (e.g., PNG, JPEG, JPG, GIF, etc.).';

  public static SUCCESS_MESSAGE_OF_ACCOUNT_LOGO_UPLOADED = 'The company logo has been successfully updated.';
  public static FAILED_TO_UPLOAD_ACCOUNT_LOGO = 'Failed to upload the company logo. Please try again later.';

  public static CONFIRMATION_HOME_ADDRESS_DELETE_TITLE = 'Delete Home Address';
  public static CONFIRMATION_HOME_ADDRESS_DELETE_MESSAGE = 'This home address will be permanently deleted from the user account. Are you sure you want to proceed?';

  public static CONFIRMATION_BUSINESS_ADDRESS_DELETE_TITLE = 'Delete Business Address';
  public static CONFIRMATION_BUSINESS_ADDRESS_DELETE_MESSAGE = 'This business address will be permanently deleted from the user account. Are you sure you want to proceed?';

  public static PROJECT_NOT_FOUND_ERROR_MESSAGE = 'Project not found. Please ensure the details are correct and try again.'
  public static BLOG_NOT_FOUND_ERROR_MESSAGE = 'Blog not found. Please ensure the details are correct and try again.'

  public static PRICE_LIST_MODAL_TYPES = {
    ADD_TO_QUOTE: 'add-to-quote',
    SAMPLE_ORDER: 'sample-order'
  }

  public static TAX_TYPE = {
    INCLUSIVE_GST: '(Inc. GST)',
    EXCLUSIVE_GST: '(Ex. GST)'
  }

  public static CARRIER_JOB = {
    JOB_CONFIRMED_TITLE: 'Job Confirmed',
    JOB_CONFIRMED_TEXT: 'Thank you for accepting this booking. Please be sure to let us know immediately if anything changes.',
    JOB_DECLINED_TITLE: 'Delivery Job Declined',
    JOB_DECLINED_TEXT: 'Our dispatching team has been notified. No further action is required.',
  }

  public static MEDIA_TYPE = {
    IMAGE: 'image',
    VIDEO: 'video',
  }
  public static INFORMATION_UPDATED_SUCCESS_MESSAGE = 'Sample Information updated successfully.'
  public static PRICE_MENU_TOOLTIP_MESSAGE = 'You must be signed in to access';

  public static ACCESSORY_CATEGORY_CORNER_ID = 4;
  public static ACCESSORY_CATEGORY_CAPPING_ID = 6;

  public static STORE_LOCATOR_STATUS = {
    ENABLED: 1,
    DISABLED: 0,
  }

  public static STORE_LOCATOR_ENABLED_SUCCESS = 'Store locator has been enabled successfully.';
  public static STORE_LOCATOR_DISABLED_SUCCESS = 'Store locator has been disabled successfully.';

  public static DEFAULT_ADDRESS_NOT_FOUND = 'No default address available. Set a default address before proceeding.';
  public static DELIVERY_ADDRESS_NOT_FOUND = 'Delivery address not found';

  public static CREDIT_EARN = {
    SHOW: 0,
    HIDE: 1,
  }

  public static CREATE_EXTERNAL_NOTES = 66
  public static UPDATE_EXTERNAL_NOTES = 67

  public static SHOW_GOOGLE_LOGIN_ERROR = 'Google Maps script is not loaded or google is not defined'
  public static ERROR_GEOLOCATION_NOT_SUPPORT = 'Geolocation is not supported by this browser.'
  public static UBABLE_TO_DOWNLOAD_RESOURCE = 'Unable to download the resource. Please try again later.'

}
